unit View.Tipos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewTiposEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbcodigo_sped: TLabel;
    edcodigo_sped: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientTiposGet: TXDataWebClient;
    XDataClientTiposDelete: TXDataWebClient;
    TiposDataset: TXDataWebDataSet;
    TiposDatasetid: TIntegerField;
    TiposDatasetaliado_id: TIntegerField;
    TiposDatasetdata_base_id: TIntegerField;
    TiposDatasetnome: TStringField;
    TiposDatasetcodigo_sped: TStringField;
    TiposDatasetcodigo_interno: TIntegerField;
    TiposDatasetexcluido: TBooleanField;
    TiposDatasetinclusao: TDateTimeField;
    TiposDatasetalteracao: TDateTimeField;
    TiposDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientTiposGetLoad(Response: TXDataClientResponse);
    procedure XDataClientTiposDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientTiposDeleteError(Error: TXDataClientError);
    procedure TiposDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewTiposEdit: TFViewTiposEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewTiposEdit }

procedure TFViewTiposEdit.btSaveClick(Sender: TObject);
begin
  if TiposDataset.State in dsEditModes then
  begin
        TiposDataset.Post;
    TiposDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewTiposEdit.btDeleteClick(Sender: TObject);
begin
  if TiposDataset.State in dsEditModes then
    TiposDataset.Post;
  XDataClientTiposDelete.Delete(TiposDataset.EntitySetName,
    TJSObject(TiposDataset.CurrentData));
end;


class function TFViewTiposEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewTiposEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewTiposEdit.InsertEntity;
begin
  TiposDataset.Close;
  TiposDataset.SetJsonData('{}');
  TiposDataset.Open;
  TiposDataset.Insert;
end;

class function TFViewTiposEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewTiposEdit(AForm).FInserting := AInserting;
    TFViewTiposEdit(AForm).FId := AId;
    TFViewTiposEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewTiposEdit(AForm).InsertEntity
    else
      TFViewTiposEdit(AForm).LoadEntity;
    TFViewTiposEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewTiposEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewTiposEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    TiposDataset.Connection.Model.DefaultSchema.FindEntityType(
      TiposDataset.EntitySetName
    )
  );
  XDataClientTiposGet.Get(TiposDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewTiposEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewTiposEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewTiposEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewTiposEdit.XDataClientTiposGetLoad(Response: TXDataClientResponse);
begin
  TiposDataset.Close;
  TiposDataset.SetJsonData(Response.Result);
  TiposDataset.Open;
  
  TiposDataset.Edit;  
end;

procedure TFViewTiposEdit.XDataClientTiposDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewTiposEdit.XDataClientTiposDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewTiposEdit.TiposDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewTiposEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewTiposEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.tipos.form.message');
  lbMessage := TLabel.Create('view.tipos.form.message.label');
  btCloseMessage := TButton.Create('view.tipos.form.message.button');
  btCancel := TButton.Create('view.tipos.form.btBack');
  btSave := TButton.Create('view.tipos.form.btSave');
  btDelete := TButton.Create('view.tipos.form.btDelete');
  lbid := TLabel.Create('view.tipos.form.lbid');
  edid := TDBEdit.Create('view.tipos.form.edid');
  lbaliado_id := TLabel.Create('view.tipos.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.tipos.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.tipos.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.tipos.form.eddata_base_id');
  lbnome := TLabel.Create('view.tipos.form.lbnome');
  ednome := TDBEdit.Create('view.tipos.form.ednome');
  lbcodigo_sped := TLabel.Create('view.tipos.form.lbcodigo_sped');
  edcodigo_sped := TDBEdit.Create('view.tipos.form.edcodigo_sped');
  lbcodigo_interno := TLabel.Create('view.tipos.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.tipos.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.tipos.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.tipos.form.edexcluido');
  lbinclusao := TLabel.Create('view.tipos.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.tipos.form.edinclusao');
  lbalteracao := TLabel.Create('view.tipos.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.tipos.form.edalteracao');
  lbexclusao := TLabel.Create('view.tipos.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.tipos.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  TiposDataset := TXDataWebDataSet.Create(Self);
  TiposDatasetid := TIntegerField.Create(Self);
  TiposDatasetaliado_id := TIntegerField.Create(Self);
  TiposDatasetdata_base_id := TIntegerField.Create(Self);
  TiposDatasetnome := TStringField.Create(Self);
  TiposDatasetcodigo_sped := TStringField.Create(Self);
  TiposDatasetcodigo_interno := TIntegerField.Create(Self);
  TiposDatasetexcluido := TBooleanField.Create(Self);
  TiposDatasetinclusao := TDateTimeField.Create(Self);
  TiposDatasetalteracao := TDateTimeField.Create(Self);
  TiposDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientTiposGet := TXDataWebClient.Create(Self);
  XDataClientTiposDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbcodigo_sped.BeforeLoadDFMValues;
  edcodigo_sped.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  TiposDataset.BeforeLoadDFMValues;
  TiposDatasetid.BeforeLoadDFMValues;
  TiposDatasetaliado_id.BeforeLoadDFMValues;
  TiposDatasetdata_base_id.BeforeLoadDFMValues;
  TiposDatasetnome.BeforeLoadDFMValues;
  TiposDatasetcodigo_sped.BeforeLoadDFMValues;
  TiposDatasetcodigo_interno.BeforeLoadDFMValues;
  TiposDatasetexcluido.BeforeLoadDFMValues;
  TiposDatasetinclusao.BeforeLoadDFMValues;
  TiposDatasetalteracao.BeforeLoadDFMValues;
  TiposDatasetexclusao.BeforeLoadDFMValues;
  XDataClientTiposGet.BeforeLoadDFMValues;
  XDataClientTiposDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewTiposEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 535;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 475;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 475;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 475;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 273;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 270;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 9;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbcodigo_sped.SetParentComponent(Self);
    lbcodigo_sped.Name := 'lbcodigo_sped';
    lbcodigo_sped.Left := 24;
    lbcodigo_sped.Top := 300;
    lbcodigo_sped.Width := 14;
    lbcodigo_sped.Height := 13;
    lbcodigo_sped.Caption := 'codigo_sped:';
    lbcodigo_sped.Transparent := True;
    edcodigo_sped.SetParentComponent(Self);
    edcodigo_sped.Name := 'edcodigo_sped';
    edcodigo_sped.Left := 221;
    edcodigo_sped.Top := 297;
    edcodigo_sped.Width := 200;
    edcodigo_sped.Height := 21;
    edcodigo_sped.Enabled := True;
    edcodigo_sped.TabOrder := 10;
    edcodigo_sped.Text := 'edcodigo_sped';
    edcodigo_sped.DataField := 'codigo_sped';
    edcodigo_sped.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 327;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 324;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 11;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 354;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 351;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 12;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 381;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 378;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 13;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 408;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 405;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 14;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 435;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 432;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 15;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := TiposDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    TiposDataset.SetParentComponent(Self);
    TiposDataset.Name := 'TiposDataset';
    TiposDataset.AfterApplyUpdates := TiposDatasetAfterApplyUpdates;
    TiposDataset.EntitySetName := 'Tipos';
    TiposDataset.Connection := DMConnection.ApiConnection;
    TiposDataset.Left := 176;
    TiposDataset.Top := 8;
    TiposDatasetid.SetParentComponent(TiposDataset);
    TiposDatasetid.Name := 'TiposDatasetid';
    TiposDatasetid.FieldName := 'id';
    TiposDatasetid.Required := True;
    TiposDatasetaliado_id.SetParentComponent(TiposDataset);
    TiposDatasetaliado_id.Name := 'TiposDatasetaliado_id';
    TiposDatasetaliado_id.FieldName := 'aliado_id';
    TiposDatasetaliado_id.Required := True;
    TiposDatasetdata_base_id.SetParentComponent(TiposDataset);
    TiposDatasetdata_base_id.Name := 'TiposDatasetdata_base_id';
    TiposDatasetdata_base_id.FieldName := 'data_base_id';
    TiposDatasetdata_base_id.Required := True;
    TiposDatasetnome.SetParentComponent(TiposDataset);
    TiposDatasetnome.Name := 'TiposDatasetnome';
    TiposDatasetnome.FieldName := 'nome';
    TiposDatasetnome.Required := True;
    TiposDatasetnome.Size := 255;
    TiposDatasetcodigo_sped.SetParentComponent(TiposDataset);
    TiposDatasetcodigo_sped.Name := 'TiposDatasetcodigo_sped';
    TiposDatasetcodigo_sped.FieldName := 'codigo_sped';
    TiposDatasetcodigo_sped.Required := False;
    TiposDatasetcodigo_sped.Size := 255;
    TiposDatasetcodigo_interno.SetParentComponent(TiposDataset);
    TiposDatasetcodigo_interno.Name := 'TiposDatasetcodigo_interno';
    TiposDatasetcodigo_interno.FieldName := 'codigo_interno';
    TiposDatasetcodigo_interno.Required := True;
    TiposDatasetexcluido.SetParentComponent(TiposDataset);
    TiposDatasetexcluido.Name := 'TiposDatasetexcluido';
    TiposDatasetexcluido.FieldName := 'excluido';
    TiposDatasetexcluido.Required := False;
    TiposDatasetinclusao.SetParentComponent(TiposDataset);
    TiposDatasetinclusao.Name := 'TiposDatasetinclusao';
    TiposDatasetinclusao.FieldName := 'inclusao';
    TiposDatasetinclusao.Required := False;
    TiposDatasetalteracao.SetParentComponent(TiposDataset);
    TiposDatasetalteracao.Name := 'TiposDatasetalteracao';
    TiposDatasetalteracao.FieldName := 'alteracao';
    TiposDatasetalteracao.Required := False;
    TiposDatasetexclusao.SetParentComponent(TiposDataset);
    TiposDatasetexclusao.Name := 'TiposDatasetexclusao';
    TiposDatasetexclusao.FieldName := 'exclusao';
    TiposDatasetexclusao.Required := False;
    XDataClientTiposGet.SetParentComponent(Self);
    XDataClientTiposGet.Name := 'XDataClientTiposGet';
    XDataClientTiposGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientTiposGet, Self, 'OnLoad', 'XDataClientTiposGetLoad');
    XDataClientTiposGet.Left := 64;
    XDataClientTiposGet.Top := 8;
    XDataClientTiposDelete.SetParentComponent(Self);
    XDataClientTiposDelete.Name := 'XDataClientTiposDelete';
    XDataClientTiposDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientTiposDelete, Self, 'OnLoad', 'XDataClientTiposDeleteLoad');
    SetEvent(XDataClientTiposDelete, Self, 'OnError', 'XDataClientTiposDeleteError');
    XDataClientTiposDelete.Left := 64;
    XDataClientTiposDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbcodigo_sped.AfterLoadDFMValues;
    edcodigo_sped.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    TiposDataset.AfterLoadDFMValues;
    TiposDatasetid.AfterLoadDFMValues;
    TiposDatasetaliado_id.AfterLoadDFMValues;
    TiposDatasetdata_base_id.AfterLoadDFMValues;
    TiposDatasetnome.AfterLoadDFMValues;
    TiposDatasetcodigo_sped.AfterLoadDFMValues;
    TiposDatasetcodigo_interno.AfterLoadDFMValues;
    TiposDatasetexcluido.AfterLoadDFMValues;
    TiposDatasetinclusao.AfterLoadDFMValues;
    TiposDatasetalteracao.AfterLoadDFMValues;
    TiposDatasetexclusao.AfterLoadDFMValues;
    XDataClientTiposGet.AfterLoadDFMValues;
    XDataClientTiposDelete.AfterLoadDFMValues;
  end;
end;

end.
